import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { replaceThemeToken } from '../../utils/replaceThemeToken';
export var colorAttributesList = {
  color: true,
  hoverColor: true
};

var replaceColor = function replaceColor(colorName, theme) {
  if (colorName.startsWith('$')) {
    return replaceThemeToken(colorName, theme).value;
  }

  var prefixedColorName = "$color.".concat(colorName);

  if (prefixedColorName in theme.referenceIndex) {
    return theme.referenceIndex[prefixedColorName];
  }

  return colorName;
};

export var colorAttributes = function colorAttributes(_ref) {
  var color = _ref.color,
      hoverColor = _ref.hoverColor,
      theme = _ref.theme;
  return css(_templateObject(), color !== undefined && "color: ".concat(replaceColor(color, theme), ";"), hoverColor !== undefined && "&:hover { color: ".concat(replaceColor(hoverColor, theme), "; }"));
};